// extracted by mini-css-extract-plugin
export default {"iconHolder":"ProfileMenu_iconHolder__4HB0+","profileIcon":"ProfileMenu_profileIcon__JFuwk","menu":"ProfileMenu_menu__C3UPU","open":"ProfileMenu_open__o40la"};